import { useState } from 'react'
import { Button, TextArea } from '@pepper/ui'

import { trimCommaSeparatedList } from 'container/Projects/LiveProjects/Project/IdeaLab/utils'

import s from './KeywordsContainingForm.module.css'

type Props = {
  onSubmit: (keywords: string) => void
  value?: string
}

export const KeywordsContainingForm = ({ onSubmit, value }: Props) => {
  const [keywords, setKeywords] = useState('')

  const trimmedKeywords = trimCommaSeparatedList(keywords)

  const handleSubmit = () => {
    onSubmit(keywords)
  }

  return (
    <div className={s.menu}>
      <div className={s.title}>Enter keywords separated by commas</div>
      <TextArea
        name="keywords-containing"
        className={s.textField}
        placeholder="Example: automation, artificial intelligence,"
        rows={4}
        onChange={e => setKeywords(e.target.value)}
      />
      <div className={s.submit}>
        <Button
          size="large"
          block={false}
          type="primary"
          onClick={handleSubmit}
          disabled={
            keywords.length === 0 ||
            value === trimmedKeywords ||
            trimmedKeywords.length === 0
          }
        >
          Submit
        </Button>
      </div>
    </div>
  )
}
